import React from 'react';
import {Redirect} from 'react-router-dom';
import {FuseUtils} from '../@fuse/index';
import {LoginConfig} from '../main/content/login/LoginConfig';
import {TrialVipsAppConfig} from '../main/content/sales/trial_vip/TrialVipsAppConfig';
import {ApplyMedicalsAppConfig} from '../main/content/adminMedical/medical/ApplyMedicalsAppConfig';
import {ProfilePageConfig} from '../main/content/profile/ProfilePageConfig';
import {MissionConfigsPageConfig} from '../main/content/callHelper/missionConfig/MissionConfigsPageConfig';
import {VipsAppConfig} from '../main/content/callHelper/vip/VipsAppConfig';
import {CompanyVipAppConfig} from '../main/content/callHelper/companyVip/CompanyVipAppConfig';
import {CompaniesAppConfig} from '../main/content/callHelper/company/CompaniesAppConfig';
import {UseRecordAppConfig} from '../main/content/callHelper/useRecord/UseRecordAppConfig';
import {MissionsAppConfig} from '../main/content/callHelper/mission/MissionsAppConfig';
import {CalendarAppConfig} from '../main/content/callHelper/calendar/CalendarAppConfig';
import {NewCalendarAppConfig} from '../main/content/callHelper/newCalendar/NewCalendarAppConfig';
import {MedicalsAppConfig} from '../main/content/callHelper/medical/MedicalsAppConfig';
import {AnalyticsDashboardAppConfig} from "../main/content/analytics/AnalyticsDashboardAppConfig";
import {CallRecordConfig} from "../main/content/callHelper/callRecord/CallRecordConfig";
import {SurveyConfig} from "../main/content/callHelper/survey/SurveyConfig";
import {SurveyCountConfig} from "../main/content/callHelper/surveyCount/SurveyCountConfig";
import {feedbackConfig} from "../main/content/callHelper/feedback/FeedbackConfig";
import {InstitutionMedicalAppConfig} from "../main/content/adminMedical/institutionMedical/InstitutionMedicalAppConfig"
import {MedicalMissionsAppConfig} from "../main/content/adminMedical/mission/MissionsAppConfig"

const routeConfigs = [
    LoginConfig,
    TrialVipsAppConfig,
    ProfilePageConfig,
    ApplyMedicalsAppConfig,
    MissionConfigsPageConfig,
    UseRecordAppConfig,
    VipsAppConfig,
    CompanyVipAppConfig,
    CompaniesAppConfig,
    MissionsAppConfig,
    CalendarAppConfig,
    NewCalendarAppConfig,
    CallRecordConfig,
    SurveyConfig,
    SurveyCountConfig,
    feedbackConfig,
    MedicalsAppConfig,
    InstitutionMedicalAppConfig,
    AnalyticsDashboardAppConfig,
    MedicalMissionsAppConfig,
];

export const routes = [
    ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
    {
        path: '/',
        component: () => <Redirect to="/profile"/>
    }
];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseRoutesConfig.js